import axios from 'axios';
import qs from 'qs';
import React, { Component } from 'react';

function Api (accessToken)
{
  const self = this;
  let token = "";
  let endpoint = process.env.REACT_APP_TOVERTAAL_API_ENDPOINT;
  let globalExceptionHandler = { transformer: false, catcher: false };

  this.setAccessToken = (t) => {
    token = t;
  }

  this.getAccessToken = () => {
    return token;
  }

  this.setGlobalExceptionHandler = (responseTransformer, responseCatcher) => {
    globalExceptionHandler = { transformer: responseTransformer, catcher: responseCatcher };
  }
  
  this.request = (method, data, uri, headers, opts = {}) => {
    uri = uri.replace(/^\//, '');

    if (token !== "") {
      headers = Object.assign({}, headers, { Authorization: "Bearer " + token });
    }

    opts = Object.assign({
      method: method,
      url: endpoint + "/" + uri,
      data: data,
      headers: headers
    }, opts);

    const instance = axios.create();

    if (globalExceptionHandler.transformer && globalExceptionHandler.catcher) {
      instance.interceptors.response.use(
        response => {
          const returnValue = globalExceptionHandler.transformer(response);
          return returnValue;
        }, 
        error => {
          const returnValue = globalExceptionHandler.catcher(error);
          return returnValue.catch(function (error) {
            if (error && error.action && error.action === 'retry') {
              console.log('api.request.retry:', new Date());
              return axios.request(error.config);
            } else {
              return Promise.reject(error);
            }
          });
        }
      );
    }

    console.log('api.request:', new Date());
    return instance.request(opts);
  }

  if (accessToken && accessToken.length) {
    this.setAccessToken(accessToken);
  }

  return this;
}

export default Api;


// WEBPACK FOOTER //
// ./src/Services/Api.js